import { render, staticRenderFns } from "./AboutObesity.vue?vue&type=template&id=6b2c2592&scoped=true&"
import script from "./AboutObesity.vue?vue&type=script&lang=js&"
export * from "./AboutObesity.vue?vue&type=script&lang=js&"
import style0 from "./AboutObesity.vue?vue&type=style&index=0&id=6b2c2592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c2592",
  null
  
)

export default component.exports